<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div class="user-profile">
  <div class="avatar-container">
    <div class="avatar" [ngStyle]="getBackgroundStyle()">
      <span *ngIf="type == 'applicant'">{{ firstInitial }}{{ lastInitial }}</span>
    </div>
  </div>
  <div class="profile-name">
    <a class="clr-primary">
      {{ userData?.firstName }} {{ userData?.lastName }}
      <i class="ti-angle-down font-12 m-l-5"></i>
    </a>
  </div>
  <small class="my-3" *ngIf="type == 'evaluator'">
    {{ userData.officeDescription }} <br />
    <span style="text-decoration: underline;">
      {{ userData.displayRole }}
    </span>
  </small>
</div>
<mat-nav-list appAccordion class="my-3">
  <div *ngFor="let menuitem of menuItems.getMenuitem(this.type)" [matTooltip]="getToolTip(menuitem)">
    <mat-list-item appAccordionLink routerLinkActive="selected" group="{{ menuitem.state }}" [disabled]="menuitem.disabled">
      <a class="" appAccordionToggle [routerLink]="[menuitem.state]" *ngIf="menuitem.type === 'link'" (click)="logMenu(menuitem);">
        <mat-icon>{{ menuitem.icon }}</mat-icon>
        <span>{{ menuitem.name }}</span>
        <span fxFlex></span>
        <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
      </a>
    </mat-list-item>
  </div>
</mat-nav-list>
